import { render } from "./Menu.vue?vue&type=template&id=d5dfc37e&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=d5dfc37e&lang=css"
import "./Menu.vue?vue&type=style&index=1&id=d5dfc37e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5dfc37e"]])

export default __exports__